var callbackFun = null;
var sendData = null;

function islogin() {
    if ($('.top .top-user').data('info')) {
        return true;
    }

    return false;
}

// callback, 当点击确认后调用该函数
window.showReportDlg = function (type, data, callback) {
    if (!islogin()) {
        showLogin();
        return;
    }

    $('#dlg-report .check-rule').prop('checked', false);
    $('#dlg-report .report-content').val('');

    sendData = data;
    callbackFun = callback;

    $('#report-rules').html('');

    $.ajax({
        type: 'get',
        async: false,
        url: '/sharereport/rules/' + type,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result && result.length > 0) {
                for (var i = 0; i < result.length; i++) {
                    var tr = '<tr>' +
                        '    <td style="width: 48px;text-align: center;"><input type="checkbox" class="check-rule"></td>' +
                        '    <td class="rule-text" style="padding-left: 15px;">' + result[i] + '</td>' +
                        '</tr>';
                    $('#report-rules').append(tr);
                }
            }

            $('#dlg-report').modal('show');
        },
        error: function (data) {
            alert(data.responseText);
        }
    });
};

$(function () {
    $('.sure-dlg-report').click(function () {
        var text = [];
        for (var i = 0; i < $('#dlg-report .check-rule').length; i++) {
            if ($('#dlg-report .check-rule').eq(i).prop('checked')) {
                var str = $('#dlg-report .check-rule').eq(i).parent().parent().find('.rule-text').text();
                text.push(str);
            }
        }
        var str = $.trim($('#dlg-report .report-content').val());

        if (text.length == 0 && str.length == 0) {
            alert('请选择一个违规选项或者填写举报内容');
            return;
        }

        if (str.length > 0) {
            text.push(str);
        }
        sendData['content'] = text.join(';');
        var phone = $.trim($('#dlg-report .report-phone').val());
        if (phone.length == 0) {
            alert('请填写电话号码');
            return;
        }
        sendData['phone_number'] = phone;
        sendReport(sendData);
    });

    function sendReport(data) {
        $.ajax({
            type: 'post',
            async: false,
            url: '/shareusers/report',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                $('#dlg-report').modal('hide');
                setTimeout(function () {
                    $('#dlg-reportresult').modal('show');
                }, 300);
                if (callbackFun) {
                    callbackFun(result);
                }
            },
            error: function (data) {
                alert(data.responseText);
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./share/client/js/report.js
// module id = 15
// module chunks = 1